interface MockVideo {
  id: string;
  title: string;
  type: "movie" | "tv";
  cover: string;
  banner?: string;
  year: number;
  region: string;
  genres: string[];
  rating: number;
  director: string;
  actors: string[];
  episodes?: number;
  updatedAt: string;
  playCount: number;
  synopsis: string;
  tags: string[];
  featured?: boolean;
}

export const tvShows: MockVideo[] = [
  {
    id: "t1",
    title: "长夜将明",
    type: "tv",
    cover: "https://readdy.ai/api/search-image?query=dark%20suspense%20tv%20series%20poster%2C%20rainy%20night%20cityscape%2C%20single%20street%20lamp%20glow%2C%20cinematic%2C%20no%20text&width=400&height=600&seq=tv-cover-01&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=cinematic%20wide%20banner%20of%20rainy%20neon%20city%20at%20night%2C%20dramatic%20suspense%20mood%2C%20no%20text&width=1600&height=900&seq=banner-02&orientation=landscape",
    year: 2024,
    region: "中国大陆",
    genres: ["悬疑", "犯罪"],
    rating: 8.8,
    director: "郑毅",
    actors: ["秦岚", "张颂文", "李一桐"],
    episodes: 32,
    updatedAt: "2024-09-28",
    playCount: 15670000,
    synopsis: "在一座永远下着雨的城市里，一名年轻检察官卷入了横跨二十年的悬案。每当长夜将明，真相与谎言就在黎明前最后交锋一次。",
    tags: ["刑侦", "烧脑", "群像"],
    featured: true,
  },
  {
    id: "t2",
    title: "云海仙途",
    type: "tv",
    cover: "https://readdy.ai/api/search-image?query=xianxia%20fantasy%20tv%20series%20poster%2C%20floating%20immortal%20mountains%20above%20clouds%2C%20ethereal%20mist%2C%20no%20text&width=400&height=600&seq=tv-cover-02&orientation=portrait",
    year: 2023,
    region: "中国大陆",
    genres: ["古装", "仙侠"],
    rating: 8.1,
    director: "白露",
    actors: ["邓为", "宋轶", "王鹤棣"],
    episodes: 40,
    updatedAt: "2024-08-15",
    playCount: 12340000,
    synopsis: "出身寒门的少年为求一线仙缘踏上云海，却在机缘与算计之中看清修仙世界的残酷。一场关于选择、执念与大道的故事缓缓展开。",
    tags: ["仙侠", "修真", "大男主"],
  },
  {
    id: "t3",
    title: "都市心跳",
    type: "tv",
    cover: "https://readdy.ai/api/search-image?query=modern%20urban%20romance%20tv%20poster%2C%20young%20couple%20on%20city%20rooftop%20at%20night%2C%20warm%20bokeh%20lights%2C%20no%20text&width=400&height=600&seq=tv-cover-03&orientation=portrait",
    year: 2024,
    region: "中国大陆",
    genres: ["爱情", "都市"],
    rating: 7.7,
    director: "林之然",
    actors: ["杨紫", "白敬亭", "金晨"],
    episodes: 24,
    updatedAt: "2024-09-20",
    playCount: 9870000,
    synopsis: "两位在同一栋大楼上班的陌生人，因为一次电梯故障结下缘分。在快节奏的都市里，他们学着慢下来，去听懂彼此的心跳。",
    tags: ["甜宠", "职场", "治愈"],
  },
  {
    id: "t4",
    title: "山河纪事",
    type: "tv",
    cover: "https://readdy.ai/api/search-image?query=epic%20historical%20tv%20series%20poster%2C%20ancient%20battlefield%20and%20banners%2C%20golden%20dust%20light%2C%20no%20text&width=400&height=600&seq=tv-cover-04&orientation=portrait",
    year: 2022,
    region: "中国大陆",
    genres: ["历史", "战争"],
    rating: 8.9,
    director: "张黎生",
    actors: ["陈道明", "王劲松", "富大龙"],
    episodes: 48,
    updatedAt: "2024-06-11",
    playCount: 11220000,
    synopsis: "以一段波澜壮阔的乱世为背景，讲述一群文臣武将在山河破碎之际的抉择与坚守。历史的重量，落在每一个具体的人身上。",
    tags: ["正剧", "权谋", "史诗"],
  },
  {
    id: "t5",
    title: "迷雾档案",
    type: "tv",
    cover: "https://readdy.ai/api/search-image?query=crime%20mystery%20tv%20poster%2C%20dim%20archive%20room%20with%20scattered%20files%2C%20single%20desk%20lamp%2C%20no%20text&width=400&height=600&seq=tv-cover-05&orientation=portrait",
    year: 2024,
    region: "中国大陆",
    genres: ["犯罪", "悬疑"],
    rating: 8.5,
    director: "韩雪",
    actors: ["段奕宏", "谭卓", "张译"],
    episodes: 30,
    updatedAt: "2024-09-08",
    playCount: 10560000,
    synopsis: "尘封多年的档案室里，一位老档案员发现了一批被刻意抹去的案件记录。随着他逐一还原真相，一张更大的网正朝他缓缓收拢。",
    tags: ["犯罪", "档案", "悬疑"],
  },
  {
    id: "t6",
    title: "青春正好",
    type: "tv",
    cover: "https://readdy.ai/api/search-image?query=youth%20campus%20tv%20poster%2C%20students%20under%20bright%20summer%20sunlight%2C%20fresh%20green%20tones%2C%20no%20text&width=400&height=600&seq=tv-cover-06&orientation=portrait",
    year: 2023,
    region: "中国大陆",
    genres: ["青春", "爱情"],
    rating: 7.4,
    director: "蒋雪",
    actors: ["张新成", "章若楠", "刘昊然"],
    episodes: 28,
    updatedAt: "2024-05-30",
    playCount: 7420000,
    synopsis: "高三的最后一年，一群少年在教室与操场之间奔跑。有关梦想、友谊与初恋的记忆，都被定格在那个最好的夏天里。",
    tags: ["校园", "青春", "励志"],
  },
  {
    id: "t7",
    title: "江山局",
    type: "tv",
    cover: "https://readdy.ai/api/search-image?query=ancient%20chinese%20palace%20intrigue%20tv%20poster%2C%20chess%20board%20and%20candle%20light%2C%20deep%20red%20and%20gold%2C%20no%20text&width=400&height=600&seq=tv-cover-07&orientation=portrait",
    year: 2024,
    region: "中国大陆",
    genres: ["古装", "权谋"],
    rating: 8.6,
    director: "赵启铭",
    actors: ["胡歌", "刘涛", "王凯"],
    episodes: 45,
    updatedAt: "2024-09-16",
    playCount: 13280000,
    synopsis: "棋局即天下，落子即人心。一位年轻的谋士被卷入朝堂之上最凶险的博弈，每一步都在生死之间，每一局都关乎江山社稷。",
    tags: ["权谋", "朝堂", "群像"],
  },
  {
    id: "t8",
    title: "星际学院",
    type: "tv",
    cover: "https://readdy.ai/api/search-image?query=sci-fi%20academy%20tv%20poster%2C%20futuristic%20space%20station%20interior%2C%20cool%20blue%20light%2C%20no%20text&width=400&height=600&seq=tv-cover-08&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=cinematic%20wide%20banner%20of%20futuristic%20space%20station%20interior%20with%20window%20to%20earth%2C%20no%20text&width=1600&height=900&seq=banner-04&orientation=landscape",
    year: 2024,
    region: "美国",
    genres: ["科幻", "青春"],
    rating: 8.0,
    director: "莉亚·摩根",
    actors: ["艾米·李", "杰克·陈", "索菲亚·罗"],
    episodes: 20,
    updatedAt: "2024-09-26",
    playCount: 8630000,
    synopsis: "在环地球轨道上的星际学院，来自各地的少年为成为合格舰员而努力。当一场意外威胁空间站，他们必须提前长大。",
    tags: ["科幻", "热血", "成长"],
    featured: true,
  },
  {
    id: "t9",
    title: "人间烟火",
    type: "tv",
    cover: "https://readdy.ai/api/search-image?query=heartwarming%20family%20tv%20poster%2C%20cozy%20warm%20kitchen%20and%20family%20dinner%2C%20soft%20light%2C%20no%20text&width=400&height=600&seq=tv-cover-09&orientation=portrait",
    year: 2023,
    region: "中国大陆",
    genres: ["家庭", "剧情"],
    rating: 8.7,
    director: "汪俊",
    actors: ["闫妮", "张嘉益", "关晓彤"],
    episodes: 36,
    updatedAt: "2024-07-25",
    playCount: 9010000,
    synopsis: "一家开了三十年的老街面馆，见证了几代人的聚散离合。柴米油盐里藏着最真实的悲欢，也藏着中国人最深的乡土情。",
    tags: ["家庭", "生活", "催泪"],
  },
  {
    id: "t10",
    title: "江湖夜雨",
    type: "tv",
    cover: "https://readdy.ai/api/search-image?query=wuxia%20tv%20series%20poster%2C%20swordsman%20in%20bamboo%20forest%20under%20rain%2C%20ink%20painting%20style%2C%20no%20text&width=400&height=600&seq=tv-cover-10&orientation=portrait",
    year: 2022,
    region: "中国大陆",
    genres: ["武侠", "古装"],
    rating: 8.4,
    director: "李国立",
    actors: ["成毅", "杨超越", "曾舜晞"],
    episodes: 40,
    updatedAt: "2024-04-18",
    playCount: 7940000,
    synopsis: "一位背负血海深仇的剑客重返江湖，在恩怨情仇中逐渐看清所谓的正邪。刀光剑影之外，他真正想寻回的是一份失去的乡愁。",
    tags: ["武侠", "江湖", "复仇"],
  },
  {
    id: "t11",
    title: "重返十八岁",
    type: "tv",
    cover: "https://readdy.ai/api/search-image?query=playful%20fantasy%20comedy%20tv%20poster%2C%20colorful%20retro%2018th%20birthday%20scene%2C%20bright%20cheerful%2C%20no%20text&width=400&height=600&seq=tv-cover-11&orientation=portrait",
    year: 2024,
    region: "中国大陆",
    genres: ["喜剧", "奇幻"],
    rating: 7.9,
    director: "李漠",
    actors: ["马丽", "白客", "尹正"],
    episodes: 24,
    updatedAt: "2024-09-05",
    playCount: 8230000,
    synopsis: "事业家庭双双遇挫的中年人一觉醒来回到了十八岁。他一边享受重来一次的机会，一边发现真正想改变的其实是现在的自己。",
    tags: ["穿越", "爆笑", "治愈"],
  },
  {
    id: "t12",
    title: "黎明前的战斗",
    type: "tv",
    cover: "https://readdy.ai/api/search-image?query=war%20drama%20tv%20poster%2C%20soldiers%20silhouettes%20at%20dawn%2C%20smoke%20and%20sunrise%2C%20muted%20tones%2C%20no%20text&width=400&height=600&seq=tv-cover-12&orientation=portrait",
    year: 2023,
    region: "中国大陆",
    genres: ["战争", "历史"],
    rating: 8.5,
    director: "康洪雷",
    actors: ["于和伟", "张桐", "黄轩"],
    episodes: 42,
    updatedAt: "2024-06-28",
    playCount: 10230000,
    synopsis: "在黎明到来之前最黑暗的时刻，一群普通士兵用血肉之躯守住了最后一道防线。他们没有名字，却撑起了整个时代的黎明。",
    tags: ["战争", "热血", "群像"],
  },
];